import { useQuery, type UseQueryResult } from 'react-query';

import { type Timestamp } from '../../services/Timestamp';
import { getQueryOptions } from '../../utils/data-fetching-utils';
import { type Mode, type PlaybackViewModel } from '../../types';

export const useFetchPlaybackData = (
  timestamp: Timestamp,
  port: string,
  mode: Mode
): UseQueryResult<PlaybackViewModel> => {
  const options = getQueryOptions(port, timestamp, mode);

  return useQuery<PlaybackViewModel, Error>(options);
};
